import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const resetPasswordUrl = `${process.env.REACT_APP_ONE_MENU_URL}/reset_password`;

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        下記よりパスワードをリセットしていただき、新しく届いたメールに記載されているURLから設定をお願いします。
        <br />
        パスワードリセット：
        <a
          className={styles.link}
          href={resetPasswordUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {resetPasswordUrl}
        </a>
      </p>
    </div>
  </div>
);

export const TEACHER_PASSWORD_FORGOTTEN_FAQ: FaqCategoryItem = {
  id: "teacher-password-forgotten-faq",
  question: "先生画面にログインするパスワードがわからない／忘れてしまった",
  Answer,
};
